import {
  API_BASE_URL,
  RFQ_URL,
  LNTNC_URL,
  LOGISTICSNOW_URL,
  IMG_CDN_URL,
  API_LOGO_BASE_URL,
  CLIENT_BASE_URL,
  TPMP_BASE_URL,
  APPLICATION_NAME,
  MAPBOX_ACCESS_TOKEN,
  GOOGLE_ANALYTICS_ID,
  MIXPANEL_TOKEN,
  CLARITY_CODE,
  EMAIL_API_URL,
  GLOBAL_GRID_DATA_URL,
  ENABLE_POPUPS as CONST_ENABLE_POPUPS,
  MAX_NUMBER_OF_SEARCHES as CONST_MAX_SEARCHES,
  POP_APPEARS_IN_MINUTES as CONST_POP_MINUTES
} from "./Components/Constants";

export const GoogleAnalyticsID = GOOGLE_ANALYTICS_ID;
export const mixpanelId = MIXPANEL_TOKEN;
export const clarityID = CLARITY_CODE;

export const ENABLE_POPUPS = CONST_ENABLE_POPUPS;
export const MAX_NUMBER_OF_SEARCHES = CONST_MAX_SEARCHES;
export const POP_APPEARS_IN_MINUTES = CONST_POP_MINUTES;

export const Urls = {
  RFQURL: RFQ_URL,
  LNTNCUrl: LNTNC_URL,
  LNBaseUrl: LOGISTICSNOW_URL,
  ImgCDN: IMG_CDN_URL,
  FileUrl: API_LOGO_BASE_URL,
  ClientBaseUrl: CLIENT_BASE_URL,
  TPMPBaseUrl: TPMP_BASE_URL,
  Autocomplete: `${API_BASE_URL}/api/apiuser/autocomplete`,
  Autocomplete1: {
    Get: {
      getlist: `${API_BASE_URL}/api/apiuser/autocomplete`,
    },
  },
  GetLocations: `${API_BASE_URL}/api/apilorri/screen_zero`,
  log: `${API_BASE_URL}/api/apilorri/log`,
  logURL: `${API_BASE_URL}/api/apilorri/log`,
  EmailApi: EMAIL_API_URL,
  streamingData: `${API_BASE_URL}/api/apilorri/streaming-data`,
  mixpanelappname: APPLICATION_NAME,
  mapboxAccessToken: MAPBOX_ACCESS_TOKEN,
  GlobalGridData: GLOBAL_GRID_DATA_URL
};
